import { EpochRequestMsg } from '#websocket/client/proto';
import { EpochRequest, EpochResponse } from './common';
export class ReportEpochRequest extends EpochRequest {
    constructor(nodeId, clientEpoch, clientConnection, destination) {
        super(EpochRequestMsg.OperationType.REPORT_EPOCH, nodeId, clientEpoch, clientConnection, destination);
    }
    createResponse(responseMessage) {
        return new EpochResponse(responseMessage);
    }
}
